"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var Article_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Article"));

var MediaManagerImage_1 = require("@sportnet/ui/lib/MediaManagerImage");

var em_1 = tslib_1.__importDefault(require("polished/lib/helpers/em"));

var prop_types_1 = tslib_1.__importDefault(require("prop-types"));

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var Slider_1 = tslib_1.__importDefault(require("../../../components/Slider"));

var propTypes_1 = require("../../../propTypes");

var utilities_1 = require("../../../utilities");

var Paging_1 = require("./Paging");

var linkClass = 'articlelist-slider-item';
var StyledDots = styled_components_1["default"](Paging_1.Dots)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding-top: ", " !important;\n"], ["\n  padding-top: ", " !important;\n"])), function (_a) {
  var theme = _a.theme;
  return em_1["default"](theme.grid.gutterWidth);
});
var StyledSlider = styled_components_1["default"](Slider_1["default"])(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  .", " {\n    padding: 0 ", ";\n  }\n"], ["\n  .", " {\n    padding: 0 ", ";\n  }\n"])), linkClass, function (_a) {
  var theme = _a.theme;
  return em_1["default"](theme.grid.gutterWidth / 2);
});

var Slider = function (_a) {
  var articles = _a.articles,
      renderLink = _a.renderLink,
      theme = _a.theme,
      className = _a.className;

  if (articles.length === 0) {
    return null;
  }

  var sliderSettings = {
    dots: true,
    slidesToShow: 1,
    swipeToSlide: true,
    centerMode: true,
    arrows: false,
    centerPadding: theme.grid.gutterWidth * 2 + "px",
    slide: "a." + linkClass,
    infinite: true,
    autoplay: true,
    appendDots: function (dots) {
      return react_1["default"].createElement(StyledDots, null, dots);
    },
    customPaging: function (i) {
      return react_1["default"].createElement(Paging_1.Dot, null);
    }
  };
  return react_1["default"].createElement(StyledSlider, tslib_1.__assign({
    className: className
  }, sliderSettings), articles.map(function (article) {
    return renderLink({
      type: utilities_1.WIDGET_LINK_TYPE.ARTICLE_DETAIL,
      payload: article,
      linkProps: {
        key: article._id,
        className: linkClass,
        draggable: false,
        children: react_1["default"].createElement(Article_1["default"], {
          title: article.name,
          subtitle: utilities_1.getArticleMeta(article),
          imgSrc: MediaManagerImage_1.getMediaManagerUrl(article.picture, 429, 322, 'media')
        })
      }
    });
  }));
};

Slider.propTypes = {
  className: prop_types_1["default"].string,
  articles: prop_types_1["default"].arrayOf(propTypes_1.ArticlePropType).isRequired,
  renderLink: prop_types_1["default"].func.isRequired
};
Slider.defaultProps = {
  className: null,
  showPicture: true
};
exports["default"] = styled_components_1.withTheme(Slider);
var templateObject_1, templateObject_2;